import React from 'react';
import { Box } from '@ant-design/plots';
import AxisConfig from "./AxisConfig";

const AntChartsBoxPlot = ({
  data,
  boxFillColor = 'linear-gradient(#28a3fd, #0082e1)',
  boxFillOpacity = 0.8,
  boxStrokeColor = '#9ed8ff',
  boxStrokeOpacity = 1,
  title = 'Box Plot',
      xAxisOptions = {}

}) => {
  const xAxis = new AxisConfig(xAxisOptions);
  const config = {
    data: {
      value: data,
    },
    xField: 'x',
    yField: 'y',
    style: {
      stroke: boxStrokeColor,
      strokeOpacity: boxStrokeOpacity,
      fill: boxFillColor,
      fillOpacity: boxFillOpacity,
    },
    animation: false,
    title: {
      text: title,
      style: {
        fontSize: 16,
      },
    },
    xAxis: {
      label: {
        formatter: (text) => {
          // Insert a line break if the text is too long
          const maxLength = 10; // Define your max length here
          if (text.length > maxLength) {
            return text.substring(0, maxLength) + '\n' + text.substring(maxLength);
          }
          return text;
        },
        autoRotate: true,  // Auto-rotate labels if needed
        autoHide: true,    // Auto-hide overlapping labels
        autoEllipsis: true // Ellipsis for overflowed text
      }
    },

  };

  return <Box {...config} />;
};

export default AntChartsBoxPlot;